export default "__VITE_ASSET__CmkvoSwO__"